type Timing = (timing: any) => any;
type Animation = number;
type Keyframes = { from: number, to: number };

interface IAnimate {
  duration: number;
  animation: (number: number) => any;
  keyframes: Keyframes;
  timing?: Timing;
  typeAnimation?: (timeFraction: Animation) => number;
  finality?: () => void;
};

export const animate = (props: IAnimate) => {
  const { duration, animation, timing, typeAnimation, keyframes }: IAnimate = props;
  let start: number = performance.now();
  const value: number = keyframes.from - keyframes.to;

  requestAnimationFrame(function animate(time) {
    let timeFraction = (time - start) / duration;

    if (timeFraction > 1) timeFraction = 1;

    let progress = !typeAnimation ? timing ? timing(timeFraction) : '' : typeAnimation(timeFraction);

    animation(Math.abs(value) * (value > 0 ? progress : 1 - progress));

    if (timeFraction < 1) {
      requestAnimationFrame(animate)
    } else {
      props.finality && props.finality();
    }
  });
};

export const EaseInOut = (timeFraction: Animation) => {
  if (timeFraction <= 0.5) return 2 * timeFraction / 2;
  else return (2 - 2 * (1 - timeFraction)) / 2;
};

export const EaseOut = (timeFraction: Animation) => 1 - timeFraction;
